import { FETCH_METHODS, SearchConfig } from "../api.model"
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { DealerDropdown, DefaultNumber, defaultSearchContainerButtons, EmpStatusDropdown, FieldNames, FirstNameText, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DisplayTranformation, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

export const TTENTenureTitle = 'T-TEN Tenure'
const TTENTenureFilterField: FormFieldConfig = {
  ...structuredClone(DefaultNumber),
  fieldName: FieldNames['Tenure'],
  displayName: TTENTenureTitle,
  camelCase:true,
  fieldCriteriaConfig: {
    operators: [
      { value: 'less than', label: 'Less than', title: 'Less Than' },
      { value: 'greater than', label: 'Greater than', title: 'Greater Than' },
      { value: 'equal to', label: 'Equal to', title: 'Equal to' }
    ],
    value: 'equal to'
  }
}
const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, {...structuredClone(tenureAreaRegionField),multiple:true, options:[]},
  {...structuredClone(DealerDropdown),fieldName:FieldNames['DealerCode'], displayName: 'T-TEN Dealer Code / T-TEN Dealer Name', options:[], displayTranformation: DisplayTranformation.none, isAutoComplete:true}, FirstNameText, LastNameText, EmpStatusDropdown, TTENTenureFilterField
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

const columnSchema: Array<TableColumnSchema> = [
  { label: "SPIN ID", fieldKey: 'spinId' },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "Job Code", fieldKey: 'job_code', isSortable: false },
  { label: "Job Description", fieldKey: 'job_description', isSortable: false },
  { label: "T-TEN Dealer Code", fieldKey: 'dealerCode', isCamelCaseHeader: true, isSortable: false },
  { label: "T-TEN Dealer Name", fieldKey: 'school_name', isCamelCaseHeader: true, isSortable: false },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "T-TEN Tenure", fieldKey: 'dealerTenure', isCamelCaseHeader: true, isColumnsMerge: true, isSortable: false }
]

export const TTENTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getTtenTenure",
  body: {
    "spinId": "",
    "area": "",
    "firstName": "",
    "lastName": "",
    "employeeStatus": "",
    "tenureCondition": "",
    "tenure": "",
    "type": "tten"
  }
}

export const TTENTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: TTENTenureSearchConfig,
}

export const TTENTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  isSortRequired: false,
  exportConfig:{
    fileName: 'T-TEN_tenure',
    exportMessage:'T-TEN Tenure data',
  },
  columnSchema: columnSchema,
  breadcrums: [{ level: 1, name: TenureTitle }, { level: 2, name: TTENTenureTitle }]
}

export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const TTENTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}